import Swiper from 'swiper'
import { A11y, Navigation } from 'swiper/modules'

const notificationBar = document.querySelector('.notification-bar__wrapper')
const notifcationBarSlides = document.querySelectorAll('.notification-bar__slides .notification-bar__slide')

// Check if Notification Bar exists
if (notificationBar) {
    // Only add slider fucntionality if there is more than one slide
    if (notifcationBarSlides.length > 1) {
        new Swiper('.notification-bar', {
            pagination: {
                el: '.notification-bar .slider-pagination',
                type: 'bullets',
                bulletClass: 'slider-pagination__item',
                bulletActiveClass: 'slider-pagination__item--active',
                clickable: true
            },
            navigation: {
                nextEl: '.notification-bar .slider-navigation__next',
                prevEl: '.notification-bar .slider-navigation__prev',
                hiddenClass: 'slider-navigation--hidden',
                disabledClass: 'slider-navigation--disabled'
            },
            effect: 'fade',
            slidesPerView: 1,
            loop: true,
            modules: [Navigation, A11y]
        })
    }
}
